export function getCookie(name) {
    const matches = document.cookie.match(new RegExp(
        `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1")}=([^;]*)`
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name, value) {
    const domain = getDomainSecondLevel();
    const date = getDataForCookie();
    const result = encodeURIComponent(name) +
        "=" +
        encodeURIComponent(value) +
        "; path=/; expires=" +
        date +
        "; domain=" +
        domain;
    document.cookie = result;
    return;
}

export function splitDot(value) {
    const result = value.split(".");
    return result;
}

function getDomainSecondLevel() {
    const splittedCurrentUrl = splitDot(document.location.hostname);
    const currentUrlLength = splittedCurrentUrl.length - 1;
    const domain = `.${splittedCurrentUrl[currentUrlLength - 1]}.${splittedCurrentUrl[currentUrlLength]}`;
    return domain;
}

function getDataForCookie() {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);
    return date;
}

// format string from format 79232401122 or +79232401122 or 89232401122 to +7-923-240-1122 or null
export function formatToMobileNumber(str, useCountyCode) {
    if (useCountyCode == undefined) useCountyCode = true;
    var cleaned = ('' + str).replace(/\D/g, '');

    var match = cleaned.match(/^([\+7]|)?([7-8]|)?(\d{3})(\d{3})(\d{2})(\d{2})$/);

    if (match) {
        var intlCode = match[1] || match[2] ? '+7' : null;

        if (!intlCode) return null;

        if (useCountyCode)
            return [intlCode, '-', match[3], '-', match[4], '-', match[5], match[6]].join('');

        return [match[3], '-', match[4], '-', match[5], match[6]].join('');
    }

    return null;
};

// format string from format +7-923-240-1122 to 79232401122 or null
export function formatMobileNumberToDigits(str) {
    var cleaned = ('' + str).replace(/\D/g, '');

    var match = cleaned.match(/^([\+7]|)?([7-8]|)?(\d{3})(\d{3})(\d{2})(\d{2})$/);

    if (match) {
        var intlCode = match[1] || match[2] ? '7' : null;

        if (!intlCode) return null;

        return [intlCode, match[3], match[4], match[5], match[6]].join('');
    }

    return null;
};

export function getNameCategoryTypeCOK(categoryType) {
    switch (categoryType) {
        case 2:
            return 'Физ. лица'
        case 4:
            return 'Юр. лица'
        case 6:
            return 'Подключение к сетям'
        case 8:
            return 'ОСП ПАО "Сбербанк России"'
    }
}


// WEBPACK FOOTER //
// ./wwwroot/app/epp.utils.js